import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as componentStore from '../component-store'

/**
 * Displays a score card component
 */
@ngCore.Component({
  imports: [
    ngCommon.NgClass,
    ds.layout.section.Component,
    ds.layout.widget.Component,
    ds.illustration.emptyState.Component,
  ],
  selector: 'atn-widget-score-card',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * Exposing {@link ents.core.common.Quality} to HTML
   */
  public readonly Quality = ents.core.common.Quality

  /** @see {@link componentStore.Widget} */
  public readonly widgetStore = ngCore.inject(
    componentStore.Widget<ents.core.mosaic.Widget.Type.ScoreCard>,
  )
}
